import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SERVICEABLE_AREA,
    GET_ALL_SERVICEABLE_AREAS,
    GET_SERVICEABLE_AREA_REQUEST,
    CREATE_SERVICEABLE_AREA,
    UPDATE_SERVICEABLE_AREA,
    DELETE_SERVICEABLE_AREA,
    CLEAR_SERVICEABLE_AREA,
    SERVICEABLE_AREA_ERROR,
    SERVICEABLE_AREA_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all serviceable areas
export const getServiceableAreas = () => async dispatch => {
    try {
        dispatch({ type: SERVICEABLE_AREA_LOADING });
        
        const res = await axios.get(`${API_URL}/serviceable-areas`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_SERVICEABLE_AREAS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get serviceable area by ID
export const getServiceableArea = (id) => async dispatch => {
    try {
        dispatch({ type: GET_SERVICEABLE_AREA_REQUEST });
        
        const res = await axios.get(`${API_URL}/serviceable-areas/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_SERVICEABLE_AREA,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create serviceable area
export const createServiceableArea = (formData) => async dispatch => {
    try {
        dispatch({ type: SERVICEABLE_AREA_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.post(`${API_URL}/serviceable-areas`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_SERVICEABLE_AREA,
                payload: res.data.data
            });
            dispatch(setAlert('Serviceable area created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create serviceable area', 'danger'));
        }
        
        dispatch({
            type: SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Update serviceable area
export const updateServiceableArea = (id, formData) => async dispatch => {
    try {
        dispatch({ type: SERVICEABLE_AREA_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.put(`${API_URL}/serviceable-areas/${id}`, formData, config);
        
        dispatch({
            type: UPDATE_SERVICEABLE_AREA,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Serviceable area updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        
        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update serviceable area', 'danger'));
        }
        
        dispatch({
            type: SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Delete serviceable area
export const deleteServiceableArea = (id) => async dispatch => {
    try {
        dispatch({ type: SERVICEABLE_AREA_LOADING });
        
        const res = await axios.delete(`${API_URL}/serviceable-areas/${id}`);
        
        dispatch({
            type: DELETE_SERVICEABLE_AREA,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Serviceable area deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: SERVICEABLE_AREA_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        dispatch(setAlert('Failed to delete serviceable area', 'danger'));
    }
};

// Clear serviceable area
export const clearServiceableArea = () => dispatch => {
    dispatch({ type: CLEAR_SERVICEABLE_AREA });
};
